import { RetractableField } from "./RetractableField";
import { StandardField } from "./StandardField";

export const DSARForm = ({ data, formData, changeData, errors }) => {
  return (
    <>
      <p className="dsar-header">{data.form.title}</p>
      <StandardField
        fields={data.fields.slice(0, 6)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <RetractableField
        fields={data.fields.slice(6, 8)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <p className="dsar-label">{data.form.data_subject.title}</p>
      <StandardField
        fields={data.fields.slice(8, 9)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <section className="dsar-form_indent">
        <p className="dsar-form_paragraph">{data.form.data_subject.ensurance}</p>
        <p className="dsar-form_paragraph">{data.form.data_subject.nature}</p>
        <p className="dsar-form_paragraph">{data.form.data_subject.identification}</p>
      </section>
      <StandardField
        fields={data.fields.slice(9, 10)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <section className="dsar-form_indent">
        <p className="dsar-form_paragraph">{data.form.data_subject.decline}</p>
      </section>
      {formData["is_data_subject"] ===
        data.fields.filter(field => field.id === "is_data_subject")[0].options[1] && (
        <>
          <p className="dsar-label">{data.form.detail_data_subject.title}</p>
          <StandardField
            fields={data.fields.slice(10, 17)}
            formData={formData}
            changeData={changeData}
            errors={errors}
          />
        </>
      )}
      <p className="dsar-label">{data.form.rights.title}</p>
      <p className="dsar-form_paragraph">{data.form.rights.identify}</p>
      <p className="dsar-form_paragraph">{data.form.rights.details}</p>
      <RetractableField
        fields={data.fields.slice(17, 31)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <section className="dsar-form_indent">
        <p className="dsar-form_paragraph">{data.form.rights.note}</p>
        <p className="dsar-form_paragraph">{data.form.rights.other_types}</p>
        <p className="dsar-form_paragraph">{data.form.rights.circumstances}</p>
      </section>
      <p className="dsar-label">{data.form.previous.title}</p>
      <p className="dsar-form_paragraph">{data.form.previous.note}</p>
      <StandardField
        fields={data.fields.slice(31, 34)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <p className="dsar-label">{data.form.declaration.title}</p>
      <p className="dsar-form_paragraph">{data.form.declaration.declaration}</p>
      <StandardField
        fields={data.fields.slice(34, 36)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
    </>
  );
};
